import React from 'react';
import styles from './styles.module.css';
import { useContext } from 'react';
import { AppContext } from '../../../AppContext';
import SyntaxHighlighter from '../../../components/SyntaxHighlighter';
import { data } from './data';
import ProTip from '../../../components/ProTip';

const lineStyle={marginLeft:-20,fontSize:16,color:'gray'}

const CandleStick=props=>{
    const { isMobile } = props;
    const appContext = useContext(AppContext);
    const { theme } = appContext;
    return(
        <div className={styles.container} style={{ paddingLeft: isMobile ? 3 : 20 }}>
            <div style={{maxWidth: 1100, marginRight: isMobile ? 0 : 130}}>
            <h2>
                Candle Stick Charts
                <a style={{marginLeft:20,fontSize:15, color: theme==='dark'? 'skyblue' : 'blue'}} target="_blank" href='https://github.com/Abhinandan-Kushwaha/react-native-gifted-charts/blob/master/docs/CandleStickChart/CandleStickChartProps.md' rel="noreferrer">
                    props table
                </a>
            </h2>
            <div style={{marginLeft:10,marginBottom:100}}>
                <p>
                    Candle Stick chart represents the open, high, low, and close prices of a security for a specific period. It supposrts all the props of Bar charts, except a few like <b>stackData</b>.
                </p>
                <img
                    src={require('../../../assets/candles.png')}
                    alt='Candle Stick Chart'
                    style={{width: 500}}
                />
                <ProTip
                    body={() => {
                        return (
                        <>
                            Candle Stick chart supposrts all the props of Bar charts, except a few like <b>stackData</b>. It internally renders a Bar chart with a few modifications (& extensions)
                        </>
                        )
                    }}
                />
                <h4>
                    Minimal Candle Stick Chart
                </h4>
                <div style={{marginLeft:10}}>
                    <img
                        src={data[0].imgSrc}
                        className={styles.barOutput}
                        alt=''/>
                    <p>
                        The code for the above chart is-
                    </p>
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {data[0].code}
                    </SyntaxHighlighter>
                </div>
            </div>
            </div>
        </div>
    )
}

export default CandleStick;